interface ConfirmNeededIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
}

export function ConfirmNeededIcon({ size = 16, style, ...props }: ConfirmNeededIconProps) {
  const sizeValue = typeof size === "number" ? `${size / 16}rem` : size;
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ width: sizeValue, height: sizeValue, ...style }}
      {...props}
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M9.2 9.2a3 3 0 0 1 5.7 1c0 2-2.9 2.6-2.9 4" />
      <path d="M12 17.5h.01" />
    </svg>
  );
}
